import React, { useState } from "react";
import { toast } from "react-toastify";
import * as hrmsService from "../../../services/hrmsService";
import { LoadState, PrimaryButton } from "../hrComponents";
import { cardStyle, formatDate, hhmm, localTime, useLoad } from "../hrUi";

// ATT-01: punch in / out from the web. The server decides everything (allowed channel, office network, lock, double tap);
// this only shows today's punches and sends one when the button is pressed.
export default function PunchCard() {
  const { data, loading, error, reload } = useLoad(() => hrmsService.getPunchToday(), []);
  const [busy, setBusy] = useState(false);
  const punches = data?.punches || [];

  const punch = async () => {
    setBusy(true);
    try {
      const res = await hrmsService.punch({ source: "WEB", direction: data.next });
      if (res?.success) {
        toast.success(res.message || "Recorded");
        reload();
      } else toast.error(hrmsService.responseMessage(res));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ ...cardStyle, padding: 20 }}>
      <LoadState loading={loading} error={error} onRetry={reload} rows={2}>
        {data ? (
          <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
            <div>
              <div style={{ fontSize: 13, color: "#6B7280" }}>{formatDate(data.date)}</div>
              <div style={{ fontWeight: 600, fontSize: 16 }}>{data.day_off ? "Day off" : data.shift ? `${data.shift.name} · ${hhmm(data.shift.start_time)}-${hhmm(data.shift.end_time)}` : "No shift planned"}</div>
              {data.site ? <div style={{ fontSize: 12, color: "#6B7280" }}>{data.site.name}</div> : null}
              <div style={{ fontSize: 13, marginTop: 8 }}>
                {punches.length === 0 ? "No punches yet today" : punches.map((p, i) => (
                  <span key={p.id} style={{ marginRight: 10 }}>
                    <strong>{i % 2 === 0 ? "In" : "Out"}</strong> {localTime(p.punched_local)}
                  </span>
                ))}
              </div>
            </div>
            {data.can_web ? (
              <PrimaryButton onClick={punch} disabled={busy} style={{ minWidth: 140, fontSize: 16, padding: "10px 24px" }}>
                {data.next === "IN" ? "Punch in" : "Punch out"}
              </PrimaryButton>
            ) : (
              <div style={{ fontSize: 13, color: "#92400E", maxWidth: 220 }}>Punching from the web is not allowed for you. Use the mobile app.</div>
            )}
          </div>
        ) : null}
      </LoadState>
    </div>
  );
}
